var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view'),_c('s-confirm',{ref:"confirm"}),_c('s-loading',{ref:"loading"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }